import Link, { LinkProps } from "@mui/joy/Link";
import { SxProps } from "@mui/joy/styles/types";
import { forwardRef } from "react";
import { Link as RouterLink } from "react-router-dom";

interface Props extends LinkProps {
  to: string;
  children: React.ReactNode;
  sx?: SxProps;
}

const ReactRouterLink = forwardRef(({ to, children, sx = [], ...props }: Props, ref: any) => {
  return (
    <Link ref={ref} component={RouterLink} to={to} {...props} sx={[...(Array.isArray(sx) ? sx : [sx])]}>
      {children}
    </Link>
  );
});
export default ReactRouterLink;
